import type { GalleryContent, Branding } from '../../../lib/site-schema';

interface Props {
  content: GalleryContent;
  branding: Branding | null;
  compact?: boolean;
}

export default function GallerySection({ content, branding, compact }: Props) {
  const primary = branding?.primaryColor || '#d97706';
  const secondary = branding?.secondaryColor || '#b45309';

  return (
    <div className={compact ? 'px-4 py-5' : 'px-6 py-10'}>
      {content.heading && (
        <div className="text-center mb-5">
          <h2
            className={`${compact ? 'text-sm' : 'text-xl'} font-bold`}
            style={{ color: '#292524', fontFamily: branding?.fontHeading, letterSpacing: '-0.01em' }}
          >
            {content.heading}
          </h2>
          <div className="w-10 h-0.5 mx-auto mt-2 rounded-full" style={{ background: primary }} />
        </div>
      )}
      <div className={`grid ${compact ? 'grid-cols-2 gap-2' : 'grid-cols-2 md:grid-cols-3 gap-3'}`}>
        {(content.images || []).map((img, i) => (
          <div key={i} className="group relative">
            <div
              className={`${compact ? 'aspect-square' : 'aspect-[4/3]'} rounded-xl overflow-hidden`}
              style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}
            >
              {img.url ? (
                <img
                  src={img.url}
                  alt={img.alt || img.label}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              ) : (
                <div
                  className="w-full h-full flex items-center justify-center"
                  style={{
                    background: `linear-gradient(135deg, ${primary}18, ${secondary}12)`,
                  }}
                >
                  <div className="text-center">
                    <span
                      className={`material-icons ${compact ? 'text-lg' : 'text-2xl'} block mb-1`}
                      style={{ color: `${primary}50` }}
                    >
                      photo_camera
                    </span>
                    {!compact && img.label && (
                      <p className="text-[10px] font-medium" style={{ color: `${primary}60` }}>{img.label}</p>
                    )}
                  </div>
                </div>
              )}
            </div>
            {compact && img.label && (
              <p className="text-[9px] text-center mt-1 font-medium" style={{ color: '#a8a29e' }}>
                {img.label}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
